import React from "react";
import { useParams2 } from "../contexts/ParamsContext";

export default function MentionsLegales() {
  const p = useParams2();
  return (
    <div className="container">
      <h1>Mentions légales</h1>
      <div className="article-content mt-2">
        <h3>Éditeur du site</h3>
        <p>
          {p.mairie_nom || "Mairie de La Chapelle-Saint-Fray"}<br />
          {p.mairie_adresse || "1 route du Mans"}<br />
          {(p.mairie_cp || "72240") + " " + (p.mairie_ville || "La Chapelle-Saint-Fray")}<br />
          {p.mairie_telephone && <>Tél. {p.mairie_telephone}<br /></>}
          {p.mairie_email && <>Courriel : {p.mairie_email}</>}
        </p>
        <h3>Directeur de la publication</h3>
        <p>Le Maire de la commune de La Chapelle-Saint-Fray.</p>
        <h3>Hébergement</h3>
        <p>Le site est hébergé sur un serveur dédié. Les données sont stockées de manière chiffrée.</p>
        <h3>Données personnelles</h3>
        <p>
          Les informations transmises via le formulaire de contact sont utilisées
          uniquement pour répondre à votre demande et ne sont pas cédées à des tiers.
          Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de
          suppression des données vous concernant en contactant la mairie.
        </p>
      </div>
    </div>
  );
}
